import React from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import Modal from '../core/Modal';

const ExportDataInfoModal = ({ visible, onClose }) => {
  const { t } = useTranslation('user');

  const exportCategories = [
    {
      label: t('export_category_profile'),
      description: t('export_category_profile_desc'),
      approxSize: '~1 KB'
    },
    {
      label: t('export_category_articles'),
      description: t('export_category_articles_desc'),
      approxSize: t('export_size_per_article')
    },
    {
      label: t('export_category_group_memberships'),
      description: t('export_category_group_memberships_desc'),
      approxSize: t('export_size_per_group')
    },
    {
      label: t('export_category_owned_groups'),
      description: t('export_category_owned_groups_desc'),
      approxSize: t('export_size_per_group')
    },
    {
      label: t('export_category_localities'),
      description: t('export_category_localities_desc'),
      approxSize: t('export_size_per_locality')
    },
    {
      label: t('export_category_reputation'),
      description: t('export_category_reputation_desc'),
      approxSize: '~0.2 KB'
    },
    {
      label: t('export_category_statistics'),
      description: t('export_category_statistics_desc'),
      approxSize: '~0.1 KB'
    }
  ];
  return (
    <Modal isOpen={visible} onClose={onClose} panelClassName="bg-white rounded-lg shadow-lg w-full max-w-md mx-4 p-6 max-h-[80vh] overflow-y-auto">
        <h3 className="text-lg font-semibold mb-2">{t('export_modal_title')}</h3>
        <p className="text-sm text-gray-500 mb-4">
          {t('export_modal_intro')}
        </p>

        <div className="space-y-3">
          {exportCategories.map((cat) => (
            <div key={cat.label}>
              <div className="flex justify-between items-baseline">
                <span className="text-sm font-semibold text-gray-800">{cat.label}</span>
                <span className="text-xs text-gray-400 ml-2 shrink-0">{cat.approxSize}</span>
              </div>
              <p className="text-xs text-gray-500 mt-0.5">{cat.description}</p>
            </div>
          ))}
        </div>

        <p className="text-xs text-gray-400 mt-4 italic">
          {t('export_total_size_note')}
        </p>

        <div className="flex justify-end mt-5">
          <button
            onClick={onClose}
            className="px-4 py-2 text-white rounded-lg transition-colors bg-[#024B99] hover:bg-[#023a7a]"
          >
            {t('common:ok')}
          </button>
        </div>
    </Modal>
  );
};

export default ExportDataInfoModal;
